module.exports = __webpack_public_path__ + "media/images/thumbs/biology/v_qv_three_and_five_prime_dna_9-31abaf5d9488d3686c1b08e1324a38cb.jpg";